import { render, staticRenderFns } from "./TipPaymentComplete.vue?vue&type=template&id=732a1568"
import script from "./TipPaymentComplete.vue?vue&type=script&lang=js"
export * from "./TipPaymentComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports